import { useFormikContext } from "formik";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { DESIGNATION_OPTIONS, type Form2848Data } from "@/features/forms/types";
import { FormikCell, FormikCheckbox, FormikSelect } from "./formik-controls";

/**
 * "Power of Attorney Given To" — the client's assigned representatives (from the
 * client profile). The user toggles which are active on this POA and edits each
 * one's designation / other licensing id; contact details come from the
 * practitioner record server-side.
 */
export function PoaRepresentativesTable() {
  const { values } = useFormikContext<Form2848Data>();
  const reps = values.representatives;

  if (reps.length === 0) {
    return (
      <p className="text-muted-foreground text-sm">
        No representatives are assigned to this client. Add them on the client's
        profile, then reopen this form.
      </p>
    );
  }

  return (
    <Card className="gap-0 overflow-x-auto overflow-hidden p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-16">Active</TableHead>
            <TableHead>Rep Name</TableHead>
            <TableHead className="w-48">Designation</TableHead>
            <TableHead className="w-44">Other ID No.</TableHead>
            <TableHead className="w-44">Other Type</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {reps.map((rep, i) => (
            <TableRow key={rep.practitioner || i}>
              <TableCell>
                <FormikCheckbox
                  name={`representatives.${i}.active`}
                  aria-label={`Active ${rep.name}`}
                />
              </TableCell>
              <TableCell className="font-medium">{rep.name}</TableCell>
              <TableCell>
                <FormikSelect
                  name={`representatives.${i}.designation`}
                  options={DESIGNATION_OPTIONS}
                  placeholder="Select…"
                  aria-label={`Designation for ${rep.name}`}
                />
              </TableCell>
              <TableCell>
                <FormikCell
                  name={`representatives.${i}.other_id`}
                  aria-label={`Other ID number for ${rep.name}`}
                />
              </TableCell>
              <TableCell>
                <FormikCell
                  name={`representatives.${i}.other_type`}
                  aria-label={`Other type for ${rep.name}`}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
